import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    push_events_value : true,
    email_events_value: true,
    settings          : [],
  },
  getters: {
    settings         : ({settings}) => settings,
    push_events_value: (state) => {
      let push = false;

      for (let [key, value] of Object.entries(state.settings)) {
        if (value.push) {
          push = true;
        }
      }
      return push;
    },
    email_events_value: (state) => {
      let email = false;

      for (let [key, value] of Object.entries(state.settings)) {
        if (value.email) {
          email = true;
        }
      }
      return email;
    },
  },
  mutations: {
    SET_STATE_NOTIFICATIONS(state, {key, value}) {
      state[key] = value;
    },
    UPDATE_NOTIFICATIONS_SETTINGS(state, {name, value, key}) {
      Object.keys(state.settings).forEach((keySettings) => {
        if (keySettings === name) {
          state.settings[keySettings][key] = value;
        }
      });
    },
    SET_CHECKBOX_PUSH(state, obj) {
      const {e, index} = obj;
      state.settings[index].push = e;
    },
    SET_CHECKBOX_MAIL(state, obj) {
      const {e, index} = obj;
      state.settings[index].email = e;
    },
    SET_PUSH_EVENTS(state, value) {
      state.push_events_value = value;
      Object.keys(state.settings).forEach((element) => {
        state.settings[element].push = value;
      });
    },
    SET_EMAIL_EVENTS(state, value) {
      state.email_events_value = value;
      Object.keys(state.settings).forEach((element) => {
        state.settings[element].email = value;
      });
    },
    SET_NOTIFICATIONS_SETTINGS(state, value) {
      let settings = value.settings;

      Object.keys(settings).forEach((key) => {
        settings[key].push = settings[key].push || false;
        settings[key].email = settings[key].email || false;
      });

      state.settings = settings;
    },
  },
  actions: {
    async get_notifications_settings({commit}) {
      try {
        let settings = await api.notifications.get_notifications_settings();
        commit('SET_NOTIFICATIONS_SETTINGS', settings.data);
      } catch (err) {
        console.error(err);
      }
    },
    async notifications_edit({}, settings) {
      let new_settings = {
        'settings': settings,
      };
      try {
        let settings = await api.notifications.edit_notifications_settings(new_settings);
        return settings;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
